import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './css/navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [atTop, setAtTop] = useState(true);
  const location = useLocation();

  // Handle scroll events with improved detection
  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      setAtTop(currentScroll <= 0);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Check initial scroll position
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when screen size increases beyond mobile breakpoint
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1170 && isOpen) {
        setIsOpen(false);
        document.body.style.overflow = 'auto';
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      document.body.style.overflow = 'hidden';
      // Add entrance animation delays to menu items
      const menuItems = document.querySelectorAll('.mobile-menu-links ul li');
      menuItems.forEach((item, index) => {
        item.style.transitionDelay = `${index * 0.1}s`;
      });
    } else {
      document.body.style.overflow = 'auto';
      // Reset delays when closing
      const menuItems = document.querySelectorAll('.mobile-menu-links ul li');
      menuItems.forEach(item => {
        item.style.transitionDelay = '0s';
      });
    }
  };

  // Enhanced close menu with animations
  const closeMenu = () => {
    const menuItems = document.querySelectorAll('.mobile-menu-links ul li');
    menuItems.forEach(item => {
      item.style.transitionDelay = '0s';
    });
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  // Check if link is active
  const isLinkActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <header className={`navbar ${isOpen ? 'menu-open' : ''} ${atTop ? 'at-top' : ''}`}>
        <div className="navbar-content" onClick={(e) => e.stopPropagation()}>
          <div className="navbar-logo">
            <Link to="/" onClick={closeMenu}>Visit Edinburgh</Link>
          </div>
          
          <nav className="desktop-navbar-links">
            <ul>
              <li>
                <Link to="/" className={isLinkActive('/') ? 'active' : ''}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/info" className={isLinkActive('/info') ? 'active' : ''}>
                  Info
                </Link>
              </li>
              <li>
                <Link to="/calendar" className={isLinkActive('/calendar') ? 'active' : ''}>
                  Calendar
                </Link>
              </li>
              <li>
                <Link to="/todo" className={isLinkActive('/todo') ? 'active' : ''}>
                  To Do
                </Link>
              </li>
              <li>
                <Link to="/chat" className={isLinkActive('/chat') ? 'active' : ''}>
                  Chat
                </Link>
              </li>
            </ul>
          </nav>
          
          <div className="desktop-navbar-actions">
            <Link to="/login" className="login-btn">Log In</Link>
            <Link to="/register" className="get-started-btn">Register</Link>
          </div>
          
          <div 
            className={`menu-icon ${isOpen ? 'open' : ''}`} 
            onClick={toggleMenu}
            role="button"
            aria-label="Toggle menu"
            aria-expanded={isOpen}
          >
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </div>
      </header>
      
      <div 
        className={`mobile-menu-backdrop ${isOpen ? 'open' : ''}`}
        onClick={closeMenu}
      />
      
      <div 
        className={`mobile-menu-overlay ${isOpen ? 'open' : ''}`}
        aria-hidden={!isOpen}
      >
        <nav className="mobile-menu-links">
          <ul>
            <li>
              <Link to="/" onClick={closeMenu} className={isLinkActive('/') ? 'active' : ''}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/info" onClick={closeMenu} className={isLinkActive('/info') ? 'active' : ''}>
                Info
              </Link>
            </li>
            <li>
              <Link to="/calendar" onClick={closeMenu} className={isLinkActive('/calendar') ? 'active' : ''}>
                Calendar
              </Link>
            </li>
            <li>
              <Link to="/todo" onClick={closeMenu} className={isLinkActive('/todo') ? 'active' : ''}>
                To Do
              </Link>
            </li>
            <li>
              <Link to="/chat" onClick={closeMenu} className={isLinkActive('/chat') ? 'active' : ''}>
                Chat
              </Link>
            </li>
          </ul>
        </nav>
        
        <div className="mobile-menu-footer">
          <Link to="/login" className="login-link" onClick={closeMenu}>Log In</Link>
          <Link to="/register" className="mobile-get-started-btn" onClick={closeMenu}>Register</Link>
        </div>
      </div>
    </>
  );
};

export default Navbar;
